export const formatNumber = (input?: number | string) => {
  if (!input) return;
  return new Intl.NumberFormat('en-US').format(Number(input));
};
